export function handleContactFormSubmit() {
    const contactForm = document.querySelector(".pul-contact-form form");
    const backLink = document.querySelector(".pul-contact-form .pul-back-link");

    if (backLink) {
        backLink.addEventListener("click", (e) => {
            e.preventDefault();
            history.back();
        });
    }

    if (contactForm) {
        // show correct fields depending on radio selection
        // const radioButtons = contactForm.querySelectorAll("input[type='radio']");
        // let visibleFields = "email"

        // for (const radioButton of radioButtons) {
        //     radioButton.addEventListener("change", () => {
        //         visibleFields = radioButton.value;

        //         contactForm.querySelectorAll(".pul-form-row--variable .pul-form-col[data-field]").forEach(field => {
        //             if (field.dataset.field === radioButton.value) {
        //                 field.classList.remove("hidden");
        //             } else {
        //                 field.classList.add("hidden");
        //             }
        //         })
        //     })
        // }

        contactForm.addEventListener("submit", (event) => {
            event.preventDefault();
            const requiredFields = contactForm.querySelectorAll(".pul-form-col:not(.hidden) [required]");
            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const submitButton = contactForm.querySelector("button[type='submit']");

            let formValid = true;

            for (const field of requiredFields) {
                field.closest(".pul-form-col").classList.remove("has-error");

                field.addEventListener("focus", () => {
                    field.closest(".pul-form-col").classList.remove("has-error");
                });

                if (field.type === "text" && field.value.trim() === "") {
                    formValid = false;
                    field.closest(".pul-form-col").classList.add("has-error");
                }

                if (field.type === "textarea" && field.value.trim() === "") {
                    formValid = false;
                    field.closest(".pul-form-col").classList.add("has-error");
                }

                if (field.type === "email" && !emailRegex.test(field.value.trim())) {
                    formValid = false;
                    field.closest(".pul-form-col").classList.add("has-error");
                }
            }

            if (!formValid) {
                document.querySelector(".has-error").scrollIntoView({ behaviour: "smooth" });
                return;
            } else {
                submit(contactForm, submitButton);
            }
        });
    }
}

async function submit(contactForm, submitButton) {
    const API_URL = contactForm.action;
    const initialText = submitButton.dataset.initialText;
    const waitingText = submitButton.dataset.waitingText;
    const successText = submitButton.dataset.successText;
    const errorRow = contactForm.querySelector(".pul-form-row--errors");

    const formData = new FormData(contactForm);

    errorRow.style.display = "none";
    errorRow.querySelector(".pul-form-col").innerHTML = "";

    submitButton.classList.add("is-loading");
    submitButton.querySelector("span").textContent = waitingText;

    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            body: new URLSearchParams(formData).toString()
        });

        const data = await response.json();

        if (data.status === "failed") {
            const error = document.createElement("span");
            error.classList.add("error-msg");
            error.textContent = data.message;
            submitButton.classList.remove("is-loading");
            submitButton.querySelector("span").textContent = initialText;

            errorRow.querySelector(".pul-form-col").appendChild(error);
            errorRow.style.display = "flex";
        } else {
            errorRow.style.display = "none";
            errorRow.querySelector(".pul-form-col").innerHTML = "";
            submitButton.querySelector("span").textContent = successText;
            submitButton.classList.remove("is-loading");
            submitButton.classList.add("is-success");

            const timeout = setTimeout(() => {
                submitButton.classList.remove("is-success");
                submitButton.querySelector("span").textContent = initialText;
                contactForm.reset();

                clearTimeout(timeout);
            }, 3000);
        }
    } catch (error) {
        console.log("Error sending form data:", error);
    }
}